import { isEqual } from 'lodash';

const filterUndefined = <T>(arr: T[]) =>
    arr.filter((item): item is NonNullable<T> => typeof item !== 'undefined');

const sameValuesExceptLast = <T, K>(array1: T[], array2: K[]) => {
    if (array1.length >= 2 && array2.length >= 2 && array1.length === array2.length) {
        return isEqual(array1.slice(0, -1), array2.slice(0, -1));
    }
};

export { filterUndefined, sameValuesExceptLast };
